// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// Tooltip from react-bootstrap not used for data-tooltip attributes
// import { Tooltip } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./Assets/css/common.css";
import "./App.css";
import { jwtDecode } from "jwt-decode";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "leaflet/dist/leaflet.css";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Loader from "./components/Loader";
import UserList from "./components/Admin/UserList";
import Authmiddleware from "./routes/Authmiddleware";
import Dashboard from "./components/Dashboard/Dashboard";
import TermsCondition from "./components/TermsCondition";
import { LoaderProvider } from "./context/LoaderContext";
import PaymentSuccess from "./components/PaymentSuccess";
import AdminDashboard from "./components/Admin/Dashboard";
import PublicPage from "./components/PublicPage/PublicPage";
import AdminAuthmiddleware from "./routes/AdminAuthmiddleware";
import CustomProfile from "./components/CustomProfile/CustomProfile";
import Home from "./components/Home/Home";
import News from "./components/News/News";
import AllFeatures from "./components/AllFeatures/AllFeatures";
import CensorCompliance from "./components/CensorCompliance/CensorCompliance";
import ReferralCodes from "./components/Admin/ReferralCodes";
import "react-tooltip/dist/react-tooltip.css";

const GOOGLE_CLIENT_ID = "655676158730-du47rruo2opgjhjve2s77tvh9e62onvd.apps.googleusercontent.com";

const authProtectedRoutes = [
  {
    path: "/user/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/user/customprofile",
    component: <CustomProfile />,
  },
];

const adminAuthProtectedRoutes = [
  {
    path: "/admin/dashboard",
    component: <AdminDashboard />,
  },
  {
    path: "/admin/user",
    component: <UserList />,
  },
  {
    path: "/admin/referral-codes",
    component: <ReferralCodes />,
  },
];

function App() {
  const token = localStorage.getItem("token");
  let decoded = null;

  try {
    if (token) {
      decoded = jwtDecode(token);
    }
  } catch (err) {
    console.error("Invalid token:", err);
    decoded = null;
  }

  useEffect(() => {
    const pageFont =
      window.localStorage.getItem("biome_page_font") || null;
    if (pageFont) {
      document.documentElement.style.setProperty("--page-font", pageFont);
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <LoaderProvider>
        <Router>
          <Loader />
          <Routes>
          <Route
            path="/"
            element={
              token && decoded?.roleId === "user" ? (
                <Navigate to="/user/dashboard" />
              ) : token && decoded?.roleId === "admin" ? (
                <Navigate to="/admin/dashboard" />
              ) : (
                <Home />
              )
            }
          />
          <Route path="/page/allfeatures" element={<AllFeatures />} />
          <Route path="/page/censorcompliance" element={<CensorCompliance />} />
          <Route path="/page/news" element={<News />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/signup" element={<Signup />} />
          <Route path="/biome/terms-condition" element={<TermsCondition />} />
          <Route path="/biome/payment-success" element={<PaymentSuccess />} />
          <Route path="/:userName" element={<PublicPage />} />

          {authProtectedRoutes?.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={<Authmiddleware>{route.component}</Authmiddleware>}
            />
          ))}
          {adminAuthProtectedRoutes?.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AdminAuthmiddleware>{route.component}</AdminAuthmiddleware>
              }
            />
          ))}
        </Routes>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
      {/* react-tooltip root element for data-tooltip-* attributes */}
      <ReactTooltip
        id="my-tooltip"
        place="left"
        effect="solid"
        backgroundColor="#333"
        textColor="#fff"
        className="custom-tooltip"
      />
      </LoaderProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
